import React from "react";

export const getNode = (ref, selector) => {
	const node = ref.current.querySelector(selector);
	return !node ? {} : node;
};

export const useRichTextAccessibility = (ref) => {
	React.useLayoutEffect(() => {
		if (!ref.current) return;

		getNode(ref, "span.ql-picker-label").setAttribute("aria-label", "Text styles");
		getNode(ref, "button.ql-bold").setAttribute("aria-label", "Bold");
		getNode(ref, "button.ql-italic").setAttribute("aria-label", "Italic");
		getNode(ref, "button.ql-underline").setAttribute("aria-label", "Underline");
		getNode(ref, "button.ql-link").setAttribute("aria-label", "Link");
		getNode(ref, "button.ql-list[value='ordered']").setAttribute("aria-label", "Ordered List");
		getNode(ref, "button.ql-list[value='bullet']").setAttribute("aria-label", "Bullet List");
		getNode(ref, "button.ql-clean").setAttribute("aria-label", "Clear formatting");
	}, []);
};
